import { useEffect } from 'react';

type JsonLdProps = {
  data: Record<string, unknown>;
  id: string;
};

export const JsonLd = ({ data, id }: JsonLdProps) => {
  const json = JSON.stringify(data);

  useEffect(() => {
    let script = document.getElementById(id) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = id;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = json;
    return () => {
      script?.remove();
    };
  }, [json, id]);

  return null;
};
